export const SLIDER_SETTINGS = {
  CONTENT_CARDS: {
    arrows: true,
    swipeToSlide: true,
    infinite: false,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1919,
        settings: {
          slidesToShow: 3.6,
        },
      },
      {
        breakpoint: 1600,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2.5,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2.5,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1.3,
        },
      },
      {
        breakpoint: 360,
        settings: {
          slidesToShow: 1.3,
        },
      },
    ],
  },
}
